$(document).on('turbolinks:load', function() {
  $('[data-scrollable]').each(function() {
    new PerfectScrollbar(this)
  })
})
